import Vue from 'vue';
import snakeCase from 'lodash/snakeCase';
import camelCase from 'lodash/camelCase';
import { APIHelper } from '@archistarai/auth-frontend';
import { showErrorNotification } from '@/assets/utils/helpers';

export default {
  state: {
    status: {
      DRAFT: 0,
      NOT_APPROVED: 20,
      AWAITING_APPROVAL: 40,
      APPROVED: 60,
      SENT_PAYMENT_LINK: 80,
      AWAITING_PAYMENT: 100,
      PAYMENT_FAILED: 120,
      PAYMENT_COMPLETE: 140,
      COMPLETED: 160
      // 'ERROR': -1,
    },
    cartNotes: [],
    clientDetails: {
      searchQuery: '',
      first_name: '',
      last_name: '',
      isReadOnly: false,
      profession: ''
    },
    companyDetails: {
      searchQuery: '',
      isReadOnly: false
    },
    paymentDetails: {
      cardDirectDebit: [],
      paymentType: 'ccdd',
      isReadOnly: false,
      sendWelcomeEmail: true,
      currency: 'AUD'
    },
    cartDetails: [],
    checkout: {},
    cartActiveTab: 0,
    statusNum: 0,
    cartGuid: null,
    assignedToGuid: null,
    linkGuid: null,
    lasModifiedBy: null,
    lasModifiedOn: null
  },
  mutations: {
    SET_CART(state, cart) {
      Object.keys(cart['cart_data']).forEach((key) => {
        Vue.set(state, camelCase(key), cart['cart_data'][key]);
      });
      Vue.set(state, 'cartGuid', cart.guid);
      Vue.set(state, 'linkGuid', cart.link_guid);
      Vue.set(state, 'assignedToGuid', cart.assignedToGuid);
      Vue.set(state, 'statusNum', cart.status);
      Vue.set(state, 'lastModifiedBy', cart.last_modified_by);
      Vue.set(state, 'lastModifiedOn', cart.last_modified_on);
    },
    UPDATE_CART(state, cart) {
      Object.keys(cart).forEach((key) => Vue.set(state, key, cart[key]));
    },
    UPDATE_CLIENT_DETAILS(state, client_details) {
      Object.keys(client_details).forEach((key) => Vue.set(state.clientDetails, key, client_details[key]));
    },
    UPDATE_COMPANY_DETAILS(state, company_details) {
      Object.keys(company_details).forEach((key) => Vue.set(state.companyDetails, key, company_details[key]));
    },
    UPDATE_PAYMENT_DETAILS(state, paymentDetails) {
      Object.keys(paymentDetails).forEach((key) => Vue.set(state.paymentDetails, key, paymentDetails[key]));
    },
    SET_CARTNOTES(state, notes) {
      state.cartNotes = notes;
    },
    CLEAR_CART(state) {
      state.cartNotes = [];
      state.cartGuid = null;
      state.cartDetails = [];
      state.clientDetails = {
        searchQuery: '',
        first_name: '',
        last_name: '',
        isReadOnly: false
      };
      state.companyDetails = {
        searchQuery: '',
        isReadOnly: false
      };
      state.paymentDetails = {
        cardDirectDebit: [],
        paymentType: 'ccdd',
        isReadOnly: false,
        sendWelcomeEmail: true,
        currency: 'AUD'
      };
      state.checkout = {};
      state.cartActiveTab = 0;
      state.cartStatus = 0;
      state.cartGuid = null;
      state.assignedToGuid = null;
      state.linkGuid = null;
      state.statusNum = 0;
    }
  },
  actions: {
    async getView({ commit }, linkGuid) {
      try {
        const response = await APIHelper.AdminAPI.get(`/cart/view/${linkGuid}`);
        commit('SET_CART', response.data.data);
      } catch (e) {
        throw e;
      }
    },
    async get({ commit }, cartGuid) {
      try {
        const response = await APIHelper.AdminAPI.get(`/cart/${cartGuid}`);
        if (typeof response.data === 'undefined' || response.data.result == 'failed') {
          if (typeof response.data !== 'undefined' && typeof response.data.message !== 'undefined')
            alert(response.data.message);
          else alert('Invalid cart');
        } else {
          commit('SET_CART', response.data.data);
          commit('SET_CARTNOTES', response.data.data.notes);
        }
        return response.data.data;
      } catch (error) {
        showErrorNotification(error);
      }
    },
    async selfCheckout({ commit, state }) {
      try {
        const cartGuid = state.cartGuid ? `/${state.cartGuid}` : '';
        let cartData = {};
        ['companyDetails', 'clientDetails', 'paymentDetails', 'cartDetails', 'checkout'].forEach((key) => {
          cartData[snakeCase(key)] = state[key];
        });
        const {
          data: { data }
        } = await APIHelper.AdminAPI.post(`/cart/self-checkout${cartGuid}`, { cart_data: cartData });
        commit('SET_CART', data);
      } catch (e) {
        if (e.response && e.response.data) {
          if (e.response.data.data.guid) {
            commit('SET_CART', e.response.data.data);
          }
        }
        throw e;
      }
    },
    async selfCheckoutUpgrade({ commit, state }) {
      try {
        const cartGuid = state.cartGuid ? `/${state.cartGuid}` : '';
        let cartData = {};
        ['companyDetails', 'clientDetails', 'paymentDetails', 'cartDetails', 'checkout'].forEach((key) => {
          cartData[snakeCase(key)] = state[key];
        });
        const {
          data: { data }
        } = await APIHelper.AdminAPI.post(`/cart/self-upgrade-checkout${cartGuid}`, { cart_data: cartData });
        console.log('UPDATE ME', data);
        //commit('SET_CART', data);
      } catch (e) {
        if (e.response && e.response.data) {
          if (e.response.data.data.guid) {
            commit('SET_CART', e.response.data.data);
          }
        }
        throw e;
      }
    },
    async contactMe() {
      try {
        const data = await APIHelper.AdminAPI.post('/contact-me');
        console.log('contactMe', data);
      } catch (e) {
        if (e.response && e.response.data) {
          if (e.response.data.data.guid) {
            alert('Something went wrong contacting , try again');
          }
        }
      }
    },
    async checkout({ commit, state, _rootState }) {
      try {
        const {
          data: { data }
        } = await APIHelper.AdminAPI.put(`/cart/checkout/${state.cartGuid}`);
        commit('SET_CART', data);
      } catch (e) {
        if (e.response && e.response.data) {
          if (e.response.data.data.guid) {
            commit('SET_CART', e.response.data.data);
          }
        }
      }
    },
    async retryPayment({ commit, state, _rootState }) {
      try {
        const {
          data: { data }
        } = await APIHelper.AdminAPI.put(`/cart/retry-payment/${state.cartGuid}`);
        commit('SET_CART', data);
        commit('SET_CARTNOTES', data.notes);
      } catch (e) {
        if (e.response && e.response.data) {
          if (e.response.data.data.guid) {
            commit('SET_CART', e.response.data.data);
          }
        }
      }
    },
    async update({ commit, state, _rootState }) {
      let cartData = {};
      ['companyDetails', 'clientDetails', 'paymentDetails', 'cartDetails', 'checkout'].forEach((key) => {
        cartData[snakeCase(key)] = state[key];
      });
      const cartGuid = state.cartGuid ? `/${state.cartGuid}` : '';
      try {
        const {
          data: {
            data: { guid }
          }
        } = await APIHelper.AdminAPI.put(`/cart${cartGuid}`, {
          cartData: JSON.stringify(cartData)
        });
        commit('UPDATE_CART', { cartGuid: guid });

        return guid;
      } catch (error) {
        showErrorNotification(error);
      }
    },
    async patchNotes({ commit, state }, notes) {
      await APIHelper.AdminAPI.patch(`/cart/notes/${state.cartGuid}`, {
        notes
      });
      commit('SET_CARTNOTES', notes);
    },
    async patchSalesUser({ commit, state }, guid) {
      if (state.cartGuid) {
        const {
          data: { data }
        } = await APIHelper.AdminAPI.patch(`/cart/sales/${state.cartGuid}`, {
          guid
        });
        commit('SET_CARTNOTES', data.notes);
      }
      commit('UPDATE_CART', { assignedToGuid: guid });
      return guid;
    },
    async generateFriendlyLink({ commit, state }) {
      const {
        data: {
          data: { link_guid: linkGuid }
        }
      } = await APIHelper.AdminAPI.put(`/cart/get-cart-link/${state.cartGuid}`);
      commit('UPDATE_CART', { linkGuid });

      return linkGuid;
    },
    async retractFriendlyLink({ commit, state }) {
      try {
        await APIHelper.AdminAPI.delete(`/cart/retract-cart-link/${state.cartGuid}`);
        commit('SET_OBJECT', { linkGuid: null });
      } catch (error) {
        showErrorNotification(error);
      }
    },
    async enrol({ state }, appId) {
      try {
        let userData = {};
        ['clientDetails'].forEach((key) => {
          const fields = state[key];
          Object.keys(fields).forEach((subKey) => {
            userData[subKey] = fields[subKey];
          });
        });
        await APIHelper.AdminAPI.post(`/enrol/${appId}`, userData);
      } catch (e) {
        throw e;
      }
    }
  }
};
